// 링크 카드. 남의 페이지가 준 글이라 **길이는 서버가 잘랐고**, 그림은 브라우저가 직접 받는다.

import { X } from 'lucide-react'
import { useT } from './i18n.ts'
import { IconButton } from './kit/button.tsx'

export interface LinkCard {
  url: string
  title: string | null
  summary: string | null
  image: string | null
  site: string | null
}

/** url → 카드. `null` 은 "물어봤는데 못 펼쳤다" — 아무것도 안 그린다. */
export type CardMap = ReadonlyMap<string, LinkCard | null>

export function LinkCardView({ card }: { card: LinkCard }) {
  if (card.title === null && card.summary === null) return null
  return (
    <a className="LinkCard" href={card.url} target="_blank" rel="noreferrer noopener">
      {card.image !== null && (
        <img src={card.image} alt="" loading="lazy" referrerPolicy="no-referrer" />
      )}
      <span className="text">
        {card.site !== null && <span className="site">{card.site}</span>}
        <span className="title">{card.title ?? card.url}</span>
        {card.summary !== null && <span className="summary">{card.summary}</span>}
      </span>
    </a>
  )
}

/**
 * 본문에 든 주소들의 카드. 아직 답이 없거나 못 펼친 것은 건너뛴다.
 * `on_hide` 는 글쓴이에게만 온다 — 카드 곁에 떼기 단추를 단다(카드는 `<a>` 라 그 안에 못 넣는다).
 */
export function LinkCards({
  urls,
  cards,
  on_hide,
}: {
  urls: readonly string[]
  cards: CardMap
  on_hide?: ((url: string) => void) | undefined
}) {
  const t = useT()
  const shown = urls.flatMap((u) => {
    const c = cards.get(u)
    return c === undefined || c === null ? [] : [c]
  })
  if (shown.length === 0) return null
  return (
    <div className="LinkCards">
      {shown.map((c) =>
        on_hide === undefined ? (
          <LinkCardView key={c.url} card={c} />
        ) : (
          <div key={c.url} className="LinkCardBox">
            <LinkCardView card={c} />
            <IconButton
              size="sm"
              className="hide"
              label={t('미리보기 삭제')}
              icon={<X />}
              onClick={() => on_hide(c.url)}
            />
          </div>
        ),
      )}
    </div>
  )
}
